<!--
 * @Description: 基于 element-ui 的数字输入组件
 * @Author: WuPuyi
 * @LastEditors: WuPuyi
 * @Date: 2021-01-26 16:32:58
 * @LastEditTime: 2021-05-27 23:13:19
-->
<template>
  <div class="input-number">
    <i
      :class="[
        'e6-icon-minus_fill',
        'input-number-icon',
        minDisabled ? 'input-number-icon--disabled' : ''
      ]"
      @click="handleSubtract"
    ></i>
    <el-input-number
      ref="input"
      :controls="false"
      v-model="myValue"
      :min="min"
      :max="max"
      :step="step"
      :precision="0"
      class="input-number-input"
    ></el-input-number>
    <i
      :class="[
        'e6-icon-add_fill',
        'input-number-icon',
        maxDisabled ? 'input-number-icon--disabled' : ''
      ]"
      @click="handleAdd"
    ></i>
  </div>
</template>

<script>
export default {
  // model: {
  //   prop: "value",
  //   event: "change"
  // },
  props: {
    value: {
      type: Number,
      default: 0
    },
    // 最小值
    min: {
      type: Number,
      default: -Infinity
    },
    // 最大值
    max: {
      type: Number,
      default: Infinity
    },
    // 计数器步长
    step: {
      type: Number,
      default: 1
    }
  },
  computed: {
    minDisabled() {
      return this.myValue === this.min;
    },
    maxDisabled() {
      return this.myValue === this.max;
    }
  },
  watch: {
    myValue(val) {
      this.$emit("change", val);
      this.$emit("input", val);
    },
    value(val) {
      this.myValue = val;
    }
  },
  mounted() {
    this.myValue = this.value;
  },
  data() {
    return {
      myValue: 0
    };
  },
  methods: {
    // 增加
    handleAdd() {
      this.$refs.input.increase();
      this.$emit("change", this.myValue);
    },
    // 减少
    handleSubtract() {
      this.$refs.input.decrease();
      this.$emit("change", this.myValue);
    }
  }
};
</script>

<style lang="scss" scoped>
.input-number {
  display: flex;
  align-items: center;
}
.input-number-input {
  margin: 0 8px;
}
.input-number-icon {
  font-size: 17px;
  color: #46bfea;
  cursor: pointer;
  &--disabled {
    color: #dfe2e9;
    cursor: not-allowed;
  }
}
</style>
